import React, { type MouseEventHandler } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

type QueryParamsNavLinkProps = {
  children: React.ReactNode;
  className: (isActive: boolean) => string;
  onClickCapture?: MouseEventHandler<HTMLAnchorElement>;
  queryParam: string;
  queryParamValue: string;
  to: string;
};

const QueryParamsNavLink = ({
  children,
  className,
  onClickCapture,
  queryParam,
  queryParamValue,
  to,
}: QueryParamsNavLinkProps) => {
  const [searchParams] = useSearchParams();
  const isActive = searchParams.get(queryParam) === queryParamValue;
  return (
    <Link className={className(isActive)} to={to} onClickCapture={onClickCapture}>
      {children}
    </Link>
  );
};

export default QueryParamsNavLink;
